module.exports = __webpack_public_path__ + "static/media/accomodation_carousel_landing.dc3f9eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/accomodation_carousel_landing.png
// module id = 1110
// module chunks = 0